import React from "react";
import { Link } from "react-router-dom";
import companyLogo from "../assets/img/CenSyn_logo.png";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tw-bg-gray-50 tw-pt-10 tw-pb-5 tw-mt-auto">
      <div className="tw-container  tw-px-4 md:tw-px-10 lg:tw-px-20">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-start tw-gap-10">
          {/* Logo & Tagline */}
          <div className="tw-flex-1">
            <Link to="/" className="tw-inline-block tw-mb-4">
              <img src={companyLogo} alt="Logo" width={200} />
            </Link>
            <p className="tw-text-sm tw-mb-4">
              Instant insights, one mind at a time
            </p>
            <div className="tw-flex tw-gap-4">
              <a className="tw-text-gray-600 hover:tw-text-gray-800" href="#!">
                <i className="fab fa-instagram"></i>
              </a>
              <a className="tw-text-gray-600 hover:tw-text-gray-800" href="#!">
                <i className="fab fa-facebook"></i>
              </a>
              <a className="tw-text-gray-600 hover:tw-text-gray-800" href="#!">
                <i className="fab fa-github"></i>
              </a>
              <a className="tw-text-gray-600 hover:tw-text-gray-800" href="#!">
                <i className="fab fa-twitter"></i>
              </a>
            </div>
          </div>

          {/* Uncomment below if you want footer columns */}
          {/* <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-6 tw-mt-8 md:tw-mt-0">
            <div>
              <h4 className="tw-uppercase tw-font-semibold tw-text-sm tw-mb-3">Product</h4>
              <ul className="tw-space-y-2 tw-text-sm">
                <li><a href="#!">PenEEG</a></li>
                <li><a href="#!">Platform</a></li>
                <li><a href="#!">Algorithms</a></li>
                <li><a href="#!">Clinical Support</a></li>
              </ul>
            </div>
            <div>
              <h4 className="tw-uppercase tw-font-semibold tw-text-sm tw-mb-3">Team</h4>
              <ul className="tw-space-y-2 tw-text-sm">
                <li><a href="#!">Founders</a></li>
                <li><a href="#!">Advisors</a></li>
                <li><a href="#!">Collaborators</a></li>
              </ul>
            </div>
            <div>
              <h4 className="tw-uppercase tw-font-semibold tw-text-sm tw-mb-3">Traction</h4>
              <ul className="tw-space-y-2 tw-text-sm">
                <li><a href="#!">Research</a></li>
                <li><a href="#!">Press Releases</a></li>
              </ul>
            </div>
            <div>
              <h4 className="tw-uppercase tw-font-semibold tw-text-sm tw-mb-3">Legal</h4>
              <ul className="tw-space-y-2 tw-text-sm">
                <li><a href="#!">Privacy Policy</a></li>
                <li><a href="#!">Terms and Conditions</a></li>
                <li><a href="#!">Contact us</a></li>
              </ul>
            </div>
          </div> */}
        </div>

        <hr className="tw-my-6 tw-border-gray-300" />

        <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-text-sm">
          <div className="tw-mb-2 md:tw-mb-0">&copy; CenSyn {currentYear}</div>
          <div className="tw-space-x-4 tw-text-black">
            <a href="#!" className="tw-text-black hover:tw-underline">
              Privacy Policy
            </a>
            <a href="#!" className="tw-text-black hover:tw-underline">
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
